import { logger } from '../../logger/logger'
import { fromLocalStorageValue } from '../localStorage/fromLocalStorageValue'
import { toLocalStorageValue } from '../localStorage/toLocalStorageValue'

export const localStorageApi = {
	getItem: (key) => {
		try {
			return fromLocalStorageValue(window.localStorage.getItem(key))
		} catch (e) {
			logger.warn('localStorageApi getItem error:', e)
			return null
		}
	},
	setItem: (key, value) => {
		try {
			window.localStorage.setItem(key, toLocalStorageValue(value))
		} catch (e) {
			logger.warn('localStorageApi setItem error:', e)
		}
	},
	removeItem: (key) => {
		try {
			window.localStorage.removeItem(key)
		} catch (e) {
			logger.warn('localStorageApi removeItem error:', e)
		}
	},
	clear: () => {
		try {
			window.localStorage.clear()
		} catch (e) {
			logger.warn('localStorageApi clear error:', e)
		}
	}
}
